import { z } from 'zod';
import type { RoleId } from '$lib/utils/roles';

const GUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

// Define schemas for type validation
export const UserSchema = z.object({
    id: z.string().regex(GUID_REGEX),
    email: z.string().email().optional().nullable(),
    companyName: z.string().optional().nullable(),
    role: z.string().optional().nullable(),
    roles: z.array(z.string()).optional().nullable(),
    companyId: z.string().regex(GUID_REGEX).optional().nullable(),
    websiteUrl: z.string().optional().nullable(),
  productSearchUrl: z.string().optional().nullable(),
    isImpersonating: z.boolean().optional().nullable(),
    originalRole: z.string().optional().nullable(),
    isActive: z.boolean().optional().nullable()
  });
  
// Response schema for the users endpoint
export const UsersResponseSchema = z.array(UserSchema);

// Type inference
export type User = z.infer<typeof UserSchema>;
export type UsersResponse = z.infer<typeof UsersResponseSchema>;

// Validation helper
export const validateUsersResponse = (data: unknown): UsersResponse => {
    return UsersResponseSchema.parse(data);
};
